const CARD_ITEMS = [
  {
    title: '最新吃瓜视频速递',
    desc: '每日精选51吃瓜视频在线最新内容，包含娱乐圈、社会热点等多领域精彩视频，不错过任何热门话题。',
    tag: '每日更新',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20toned%20abstract%20news%20card%20illustration%20with%20geometric%20shapes%20and%20notification%20motifs%2C%20modern%20editorial%20design%20aesthetic%2C%20clean%20minimalist%20composition%2C%20soft%20gradient%20background%2C%20high%20detail%20digital%20art&width=640&height=420&seq=card-item-01&orientation=landscape',
  },
  {
    title: '热门综艺吃瓜盘点',
    desc: '各大综艺名场面合集，51吃瓜在线观看带你回顾那些笑点与泪点齐飞的经典片段。',
    tag: '综艺',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20amber%20golden%20abstract%20variety%20show%20card%20illustration%20with%20confetti%20and%20spotlight%20motifs%2C%20fun%20entertaining%20design%20aesthetic%2C%20clean%20minimalist%20composition%2C%20soft%20gradient%2C%20high%20detail%20digital%20art&width=640&height=420&seq=card-item-02&orientation=landscape',
  },
  {
    title: '明星动态一手掌握',
    desc: '51吃瓜网在线观看实时追踪明星最新动态，第一时间获取娱乐圈一手资讯。',
    tag: '明星',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20peach%20toned%20abstract%20celebrity%20news%20card%20illustration%20with%20star%20and%20camera%20motifs%2C%20glamorous%20modern%20design%20aesthetic%2C%20clean%20composition%2C%20soft%20gradient%2C%20high%20detail%20digital%20art&width=640&height=420&seq=card-item-03&orientation=landscape',
  },
  {
    title: '社会热点深度解读',
    desc: '不止娱乐，51吃瓜视频在线还为您精选社会热点话题，多角度还原事件全貌。',
    tag: '热点',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20abstract%20social%20news%20card%20illustration%20with%20globe%20and%20connection%20motifs%2C%20insightful%20editorial%20design%20aesthetic%2C%20clean%20composition%2C%20soft%20gradient%2C%20high%20detail%20digital%20art&width=640&height=420&seq=card-item-04&orientation=landscape',
  },
  {
    title: '51cg吃瓜直播回放',
    desc: '错过直播？没关系，51cg吃瓜直播高清回放随时随地补课，精彩内容一个不落。',
    tag: '直播',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20amber%20abstract%20live%20stream%20card%20illustration%20with%20play%20button%20and%20waveform%20motifs%2C%20dynamic%20broadcasting%20design%20aesthetic%2C%20clean%20composition%2C%20soft%20gradient%2C%20high%20detail%20digital%20art&width=640&height=420&seq=card-item-05&orientation=landscape',
  },
  {
    title: '51吃瓜影视免费看',
    desc: '精选热门影视作品免费在线观看，51吃瓜影视专区为您打造舒适的追剧观影体验。',
    tag: '影视',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20golden%20abstract%20movie%20card%20illustration%20with%20film%20reel%20and%20popcorn%20motifs%2C%20cozy%20cinema%20design%20aesthetic%2C%20clean%20composition%2C%20soft%20gradient%2C%20high%20detail%20digital%20art&width=640&height=420&seq=card-item-06&orientation=landscape',
  },
];

export default function AppCardsSection() {
  return (
    <>
      {/* #app - 1 mobile entry */}
      <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/60">
            <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20coral%20toned%20abstract%20mobile%20app%20icon%20design%20with%20geometric%20minimalist%20style%2C%20rounded%20square%20shape%2C%20soft%20gradient%20background%2C%20modern%20app%20aesthetic%2C%20clean%20and%20simple%2C%20high%20detail%20digital%20illustration&width=400&height=400&seq=app-qr-placeholder&orientation=squarish"
                alt="51吃瓜APP下载"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.classList.add('flex', 'items-center', 'justify-center');
                    const icon = document.createElement('i');
                    icon.className = 'ri-download-cloud-2-line text-4xl text-foreground-400';
                    parent.appendChild(icon);
                  }
                }}
              />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
                下载51吃瓜APP
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5 max-w-lg">
                51吃瓜网在线观看移动客户端现已支持iOS和Android双平台，随时随地畅享51吃瓜视频在线、51cg吃瓜直播等全部功能。
                移动端专属优化，加载更快更省流量，推送热门吃瓜内容不遗漏。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="w-full sm:w-auto px-5 py-3 rounded-lg bg-foreground-900 text-white font-medium text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-fill mr-1.5"></i>App Store
                </button>
                <button className="w-full sm:w-auto px-5 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-android-line mr-1.5"></i>Android 下载
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* #cards - 6 info cards */}
      <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 mb-3">
              精选内容推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              51吃瓜网在线观看为您精心挑选的优质吃瓜内容
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {CARD_ITEMS.map((card, idx) => (
              <div
                key={idx}
                className="group rounded-xl overflow-hidden border border-background-200/60 bg-background-50 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[3/2] overflow-hidden bg-background-200">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap">{card.tag}</span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-1">
                    {card.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {card.desc}
                  </p>
                  <div className="mt-3 flex items-center text-primary-500 text-xs font-medium">
                    <span className="whitespace-nowrap">了解更多</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:ml-2 transition-all"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}